var _path, _g, _path2, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertificationDone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 128,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "certification-done_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 129,
    height: 128
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M.5 0h128v128H.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#certification-done_svg__a)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#certification-done_svg__filter0_d_875_34058)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.516 103.102c8.219 0 14.882-6.678 14.882-14.916v-50.17c0-8.237-6.663-14.914-14.882-14.914H32.281c-8.22 0-14.883 6.677-14.883 14.915v50.17c0 8.237 6.663 14.915 14.883 14.915h62.235zM32.473 36a3 3 0 000 6h61.85a3 3 0 000-6h-61.85zm-3 15a3 3 0 013-3h35.908a3 3 0 010 6H32.473a3 3 0 01-3-3zm3 9a3 3 0 000 6h18.945a3 3 0 000-6H32.473z",
    fill: "url(#certification-done_svg__paint0_linear_875_34058)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "certification-done_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 58,
    width: 65,
    height: 64
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M55.5 58h64v64h-64z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#certification-done_svg__filter1_d_875_34058)",
    mask: "url(#certification-done_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.766 94.8l-5.733-5.733c-.489-.489-1.111-.733-1.867-.733-.755 0-1.377.244-1.866.733-.49.49-.734 1.111-.734 1.867 0 .755.245 1.378.734 1.867l7.6 7.6c.533.533 1.155.8 1.866.8.712 0 1.334-.267 1.867-.8L100.7 85.334c.489-.489.733-1.111.733-1.867 0-.755-.244-1.377-.733-1.866-.489-.49-1.111-.734-1.867-.734s-1.378.245-1.867.734l-13.2 13.2zm3.734 21.867c-3.69 0-7.156-.7-10.4-2.1-3.245-1.4-6.067-3.3-8.467-5.7-2.4-2.4-4.3-5.222-5.7-8.466-1.4-3.245-2.1-6.712-2.1-10.4 0-3.69.7-7.156 2.1-10.4 1.4-3.245 3.3-6.067 5.7-8.467 2.4-2.4 5.222-4.3 8.467-5.7 3.244-1.4 6.71-2.1 10.4-2.1 3.689 0 7.155.7 10.4 2.1 3.244 1.4 6.066 3.3 8.466 5.7 2.4 2.4 4.3 5.222 5.7 8.467 1.4 3.244 2.1 6.71 2.1 10.4 0 3.688-.7 7.155-2.1 10.4-1.4 3.244-3.3 6.066-5.7 8.466-2.4 2.4-5.222 4.3-8.466 5.7-3.245 1.4-6.711 2.1-10.4 2.1z",
    fill: "url(#certification-done_svg__paint1_linear_875_34058)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.766 94.321l-5.493-5.493c-.559-.56-1.27-.833-2.107-.833-.836 0-1.547.274-2.106.833-.559.558-.833 1.27-.833 2.106 0 .836.274 1.548.833 2.106l7.6 7.6c.593.593 1.3.9 2.106.9.807 0 1.514-.307 2.107-.9l15.066-15.066c.559-.559.833-1.27.833-2.107 0-.836-.274-1.547-.833-2.106-.558-.559-1.27-.833-2.106-.833-.836 0-1.548.274-2.106.833l-12.96 12.96zm3.734 22.007c-3.645 0-7.066-.691-10.266-2.072-3.207-1.384-5.993-3.26-8.361-5.628-2.369-2.369-4.245-5.155-5.629-8.362-1.38-3.2-2.072-6.62-2.072-10.265 0-3.645.691-7.066 2.072-10.266 1.384-3.207 3.26-5.993 5.629-8.361 2.368-2.369 5.154-4.245 8.361-5.629 3.2-1.38 6.62-2.072 10.266-2.072 3.644 0 7.065.691 10.265 2.072 3.207 1.384 5.993 3.26 8.362 5.629 2.368 2.368 4.244 5.154 5.628 8.361 1.381 3.2 2.072 6.62 2.072 10.266 0 3.644-.691 7.065-2.072 10.265-1.384 3.207-3.26 5.993-5.628 8.362-2.369 2.368-5.155 4.244-8.362 5.628-3.2 1.381-6.62 2.072-10.265 2.072z",
    stroke: "#fff",
    strokeOpacity: 0.14,
    strokeWidth: 0.678
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "certification-done_svg__paint0_linear_875_34058",
    x1: 63.398,
    y1: 103.102,
    x2: 63.398,
    y2: 21.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B2DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#019ABC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certification-done_svg__paint1_linear_875_34058",
    x1: 59.458,
    y1: 101.927,
    x2: 116.191,
    y2: 101.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFCFF"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "certification-done_svg__filter0_d_875_34058",
    x: -14.602,
    y: -4.898,
    width: 156,
    height: 144,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.00392157 0 0 0 0 0.627451 0 0 0 0 0.764706 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_875_34058"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_875_34058",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "certification-done_svg__filter1_d_875_34058",
    x: 56.765,
    y: 63.334,
    width: 61.469,
    height: 61.47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.068
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.034
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.32549 0 0 0 0 0.717647 0 0 0 0 0.835294 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_875_34058"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_875_34058",
    result: "shape"
  })))));
}
export default SvgCertificationDone;